import React from 'react';
import { useSelector } from 'react-redux';
import Authenticated from './components/Authenticated';
import ForgotPassword from './components/ForgotPassword';
import LoginForm from './components/LoginForm';

const WbLogin = () => {
  const { authenticated, forgotPassword } = useSelector((state) => state.user);

  if (forgotPassword) {
    return <ForgotPassword />;
  }

  return authenticated ? <Authenticated /> : <LoginForm />;
};

export default WbLogin;
